<div class="mb-3 relative">
  <input #searchInput
    [ngModel]="searchTerm()"
    (ngModelChange)="onSearchTermChange($event)"
    (search)="onNativeSearch(searchInput, $event)"
    type="search"
    autocomplete="off"
    data-testid="list-search"
    placeholder="    {{ 'Search' | translate }}..."
    class="p-2 pl-3 pr-10 border border-gray-300 rounded-full w-full shadow-sm text-sm text-center focus:text-left focus:pl-3 transition-all duration-200">
  <div class="absolute right-3 top-2.5 pointer-events-none">
    @switch (searchState) {
    @case ('idle') {
    <svg xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5 text-gray-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
    }
    @case ('typing') {
    <div class="flex space-x-1 items-center h-5">
      <div class="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce [animation-delay:0ms]"></div>
      <div class="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce [animation-delay:150ms]"></div>
      <div class="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce [animation-delay:300ms]"></div>
    </div>
    }
    @case ('searching') {
    <i class="fas fa-spinner fa-spin text-gray-500 text-lg -mt-6"></i>
    }
    }
  </div>
</div>